import { useForm } from 'react-hook-form';
import { useEffect, useState } from 'react';
import getCity from '../../api/getCity';
import { getInsurance } from '../../api/getInsurance';
import { useNavigate } from 'react-router-dom';
import { buildSearch } from '../../common/utils/url';
import fetchAuthenticatedUser from '../../api/fetchAuthenticatedUser';
import { format } from 'date-fns';
 
const useSearch = () => {
  const [formError, setFormError] = useState(false);
  const [error, setError] = useState('');
  const [cities, setCities] = useState([]);
  const [insurance, setInsurance] = useState([]);
  const navigate = useNavigate();
  const { control, handleSubmit, register, reset, getValues, setValue, watch } = useForm();
 
  const onSearch = async ({ doctorName, insurance, specialty, secondarySpecialty, date: dateData, city }) => {
  
    let date;
    setError('');
    
      setFormError(false);
      if (dateData) {
        date = format(dateData, "yyyy-MM-dd");
      }
      const getOptionId = (item) => item?.value ?? item?.id ?? item?.secondaryId;
      const specialtyIds = Array.isArray(specialty)
        ? specialty.map((item) => getOptionId(item)).filter(Boolean).join(',')
        : '';
      const secondarySpecialtyIds = Array.isArray(secondarySpecialty)
        ? secondarySpecialty.map((item) => getOptionId(item)).filter(Boolean).join(',')
        : '';
      const specialtyLabels = Array.isArray(specialty) ? specialty.map((item) => item?.label).filter(Boolean) : [];
      const secondaryLabels = Array.isArray(secondarySpecialty)
        ? secondarySpecialty.map((item) => item?.label).filter(Boolean)
        : [];
      const specialtyQuery = [...new Set([...specialtyLabels, ...secondaryLabels])].join(',');
      const insuranceQuery = Array.isArray(insurance)
        ? insurance.map((item) => item?.label).filter(Boolean).join(',')
        : insurance?.label || insurance || '';

      const baseSearch = buildSearch({
        doctorName: doctorName,
        insurance: insuranceQuery,
        q: specialtyQuery,
        speciality: specialtyIds,
        secondarySpeciality: secondarySpecialtyIds,
        date,
        city: city?.id
      });
      const refreshToken = `_r=${Date.now()}`;
      const search = baseSearch ? `${baseSearch}&${refreshToken}` : `?${refreshToken}`;

      // const user = await fetchAuthenticatedUser();
      // if (user.id)
        navigate({
          pathname: '/search-results',
          search
        });
      // else setError('Tienes que iniciar sesión para realizar la búsqueda');
    //  else {
    //   setFormError(true);
    //   navigate({
    //     pathname: '/'
    //   })
    // }
  };
 
  useEffect(() => {
    const getData = async () => {
      const data = await getCity(setError);
      if (Array.isArray(data) && data.length > 0) {
        const formattedCities = data
          .map((city) => ({
            ...city,
            label: city?.name ?? city?.cityName ?? city?.label,
            value: city?.name ?? city?.cityName ?? city?.label
          }))
          .sort((a, b) => {
            // Normalize and compare case-insensitively for Spanish
            const labelA = (a.label || '').toLowerCase().trim();
            const labelB = (b.label || '').toLowerCase().trim();
            return labelA.localeCompare(labelB, 'es', { 
              sensitivity: 'base',
              numeric: true,
              ignorePunctuation: true
            });
          });
        setCities(formattedCities);
      } else {
        setCities([]);
      }
    };

    getData();
  }, []);
 
  return { control, handleSubmit, onSearch, formError, register, cities, error, reset, getValues, setValue, watch };
};
 
export default useSearch;